const USER_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[userManagementExperience] createUser',
  SET_CREATED: '[userManagementExperience] setCreated',
  EDIT: '[userManagementExperience] editUser',
  DELETE: '[userManagementExperience] deleteUser'
}

export default USER_MANAGEMENT_EXPERIENCE_TYPES
